import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';
import { LocationContext } from '../../contexts/LocationContext';
import { SingleEntry } from '../../graphql-fragments/navigationMenu';
import { getLocalizedUrlPath } from '../../utils/i18n';
import { getUrlFromVersatileLink } from '../../utils/sanity';
import { checkUrlsMatch, clsx } from '../../utils/utils';
import * as styles from './MenuEntry.module.scss';
import SmartLink from './SmartLink';

export interface MenuEntryProps {
  entry: SingleEntry;
  withMorePaddingLeft?: boolean;
  headerWithOpaqueBackground?: boolean;
  isMobile?: boolean;
  isSubEntry?: boolean;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
}

const MenuEntry = ({
  entry,
  withMorePaddingLeft,
  headerWithOpaqueBackground,
  isMobile,
  isSubEntry,
  className,
  onClick,
}: MenuEntryProps): React.ReactElement => {
  const location = useContext(LocationContext);
  const { i18n } = useTranslation();

  return (
    <SmartLink
      onClick={onClick}
      to={getUrlFromVersatileLink(entry)}
      className={clsx(
        styles.link,
        isMobile && styles.mobile,
        isSubEntry && styles.subEntry,
        location &&
          checkUrlsMatch(
            location.pathname,
            getLocalizedUrlPath(getUrlFromVersatileLink(entry), i18n.language),
          ) &&
          styles.active,
        withMorePaddingLeft && styles.morePaddingLeft,
        headerWithOpaqueBackground && styles.headerWithOpaqueBackground,
        className,
      )}
    >
      {entry.title}
    </SmartLink>
  );
};

export default MenuEntry;
